/**
 * Created by alvinoktavianus on 6/22/17.
 */

export const BILLING_NOTIFICATION_SHOW_BILLING_NOTIFICATION = 'BILLING_NOTIFICATION_SHOW_BILLING_NOTIFICATION'



// WEBPACK FOOTER //
// ./app/actions/billingNotification/constant.js